// Mock data for Italian Fast Delivery
// NOTE: This is MOCK data used for the frontend-only build.

export const categories = [
  { id: 'pizza', name: 'Pizza', image: 'https://images.pexels.com/photos/6068717/pexels-photo-6068717.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { id: 'pasta', name: 'Pasta', image: 'https://images.pexels.com/photos/31637793/pexels-photo-31637793.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { id: 'sushi', name: 'Sushi', image: 'https://images.pexels.com/photos/28291554/pexels-photo-28291554.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { id: 'burger', name: 'Burger', image: 'https://images.pexels.com/photos/33502810/pexels-photo-33502810.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { id: 'insalate', name: 'Insalate', image: 'https://images.pexels.com/photos/13630358/pexels-photo-13630358.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { id: 'kebab', name: 'Kebab', image: 'https://images.pexels.com/photos/37080266/pexels-photo-37080266.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { id: 'healthy', name: 'Healthy', image: 'https://images.pexels.com/photos/8481855/pexels-photo-8481855.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { id: 'dolci', name: 'Dolci', image: 'https://images.pexels.com/photos/684968/pexels-photo-684968.jpeg?auto=compress&cs=tinysrgb&w=400' },
];

const pizzaMenu = [
  { id: 'p1', name: 'Margherita', description: 'Pomodoro San Marzano, mozzarella fiordilatte, basilico fresco', price: 7.5, image: 'https://images.pexels.com/photos/6068717/pexels-photo-6068717.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Pizze Classiche' },
  { id: 'p2', name: 'Diavola', description: 'Pomodoro, mozzarella, salame piccante', price: 9.0, image: 'https://images.pexels.com/photos/9993754/pexels-photo-9993754.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Pizze Classiche' },
  { id: 'p3', name: 'Quattro Formaggi', description: 'Mozzarella, gorgonzola, fontina, grana padano', price: 10.0, image: 'https://images.pexels.com/photos/6068717/pexels-photo-6068717.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Pizze Speciali' },
  { id: 'p4', name: 'Capricciosa', description: 'Pomodoro, mozzarella, prosciutto cotto, funghi, carciofi, olive', price: 10.5, image: 'https://images.pexels.com/photos/9993754/pexels-photo-9993754.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Pizze Speciali' },
  { id: 'p5', name: 'Coca-Cola 33cl', description: 'Lattina ghiacciata', price: 2.5, image: '', section: 'Bevande' },
];

const pastaMenu = [
  { id: 'pa1', name: 'Spaghetti alla Carbonara', description: 'Guanciale, uova, pecorino romano, pepe nero', price: 11.0, image: 'https://images.pexels.com/photos/31637793/pexels-photo-31637793.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Primi Piatti' },
  { id: 'pa2', name: 'Penne all\'Arrabbiata', description: 'Pomodoro, aglio, peperoncino, prezzemolo', price: 9.5, image: 'https://images.pexels.com/photos/31637791/pexels-photo-31637791.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Primi Piatti' },
  { id: 'pa3', name: 'Lasagna alla Bolognese', description: 'Ragù di carne, besciamella, parmigiano', price: 12.5, image: 'https://images.pexels.com/photos/31637793/pexels-photo-31637793.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Primi Piatti' },
  { id: 'pa4', name: 'Tiramisù', description: 'Mascarpone, savoiardi, caffè, cacao', price: 5.0, image: 'https://images.pexels.com/photos/684968/pexels-photo-684968.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Dolci' },
];

const sushiMenu = [
  { id: 's1', name: 'Sushi Mix 12 pz', description: 'Selezione di nigiri e maki del giorno', price: 14.0, image: 'https://images.pexels.com/photos/28291554/pexels-photo-28291554.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Sushi' },
  { id: 's2', name: 'California Roll 8 pz', description: 'Surimi, avocado, philadelphia, sesamo', price: 8.5, image: 'https://images.pexels.com/photos/28291554/pexels-photo-28291554.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Roll' },
  { id: 's3', name: 'Salmon Nigiri 6 pz', description: 'Riso, salmone fresco', price: 9.0, image: 'https://images.pexels.com/photos/28291554/pexels-photo-28291554.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Nigiri' },
  { id: 's4', name: 'Edamame', description: 'Fagioli di soia al vapore con sale', price: 4.5, image: '', section: 'Antipasti' },
];

const burgerMenu = [
  { id: 'b1', name: 'Classic Cheeseburger', description: 'Manzo 180g, cheddar, insalata, pomodoro, salsa speciale', price: 9.5, image: 'https://images.pexels.com/photos/33502810/pexels-photo-33502810.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Burger' },
  { id: 'b2', name: 'Bacon BBQ Burger', description: 'Manzo, bacon croccante, cheddar, salsa BBQ, cipolla', price: 11.0, image: 'https://images.pexels.com/photos/33502810/pexels-photo-33502810.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Burger' },
  { id: 'b3', name: 'Patatine Fritte', description: 'Porzione abbondante con sale', price: 3.5, image: '', section: 'Contorni' },
  { id: 'b4', name: 'Chicken Burger', description: 'Pollo croccante, maionese, insalata', price: 9.0, image: 'https://images.pexels.com/photos/33502810/pexels-photo-33502810.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Burger' },
];

const kebabMenu = [
  { id: 'k1', name: 'Kebab nel Pane Arabo', description: 'Carne mista, insalata, pomodoro, salse a scelta', price: 6.0, image: 'https://images.pexels.com/photos/37080266/pexels-photo-37080266.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Kebab' },
  { id: 'k2', name: 'Piadina Kebab', description: 'Carne, formaggio, verdure', price: 6.5, image: 'https://images.pexels.com/photos/37080266/pexels-photo-37080266.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Kebab' },
  { id: 'k3', name: 'Falafel Box', description: 'Falafel di ceci, hummus, insalata', price: 7.0, image: 'https://images.pexels.com/photos/8481855/pexels-photo-8481855.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Vegetariano' },
];

const healthyMenu = [
  { id: 'h1', name: 'Poke Bowl Salmone', description: 'Riso, salmone, avocado, edamame, mango', price: 12.0, image: 'https://images.pexels.com/photos/8481855/pexels-photo-8481855.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Poke Bowl' },
  { id: 'h2', name: 'Caesar Salad', description: 'Pollo grigliato, insalata romana, crostini, parmigiano', price: 10.0, image: 'https://images.pexels.com/photos/13630358/pexels-photo-13630358.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Insalate' },
  { id: 'h3', name: 'Buddha Bowl Veg', description: 'Quinoa, ceci, avocado, verdure di stagione', price: 11.0, image: 'https://images.pexels.com/photos/8481855/pexels-photo-8481855.jpeg?auto=compress&cs=tinysrgb&w=500', section: 'Poke Bowl' },
];

export const restaurants = [
  {
    id: 'pizzeria-napoli',
    name: 'Pizzeria Da Napoli',
    cuisine: 'Pizza · Italiana',
    categories: ['pizza', 'pasta'],
    image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    rating: 4.7,
    reviews: 1240,
    deliveryTime: '25-35 min',
    deliveryFee: 1.99,
    minOrder: 10,
    promo: 'Consegna Gratis sopra 20€',
    address: 'Via Roma 12, Milano',
    featured: true,
    menu: pizzaMenu,
  },
  {
    id: 'trattoria-bella',
    name: 'Trattoria Bella Italia',
    cuisine: 'Pasta · Tradizionale',
    categories: ['pasta', 'dolci'],
    image: 'https://images.unsplash.com/photo-1498579150354-977475b7ea0b?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    rating: 4.8,
    reviews: 980,
    deliveryTime: '30-40 min',
    deliveryFee: 2.49,
    minOrder: 12,
    promo: '-20% sul primo ordine',
    address: 'Corso Buenos Aires 45, Milano',
    featured: true,
    menu: pastaMenu,
  },
  {
    id: 'sushi-zen',
    name: 'Sushi Zen',
    cuisine: 'Sushi · Giapponese',
    categories: ['sushi', 'healthy'],
    image: 'https://images.pexels.com/photos/28291554/pexels-photo-28291554.jpeg?auto=compress&cs=tinysrgb&w=800',
    rating: 4.6,
    reviews: 1530,
    deliveryTime: '35-45 min',
    deliveryFee: 2.99,
    minOrder: 15,
    promo: null,
    address: 'Via Torino 8, Milano',
    featured: true,
    menu: sushiMenu,
  },
  {
    id: 'burger-house',
    name: 'Burger House',
    cuisine: 'Burger · Americano',
    categories: ['burger'],
    image: 'https://images.pexels.com/photos/33502810/pexels-photo-33502810.jpeg?auto=compress&cs=tinysrgb&w=800',
    rating: 4.5,
    reviews: 2100,
    deliveryTime: '20-30 min',
    deliveryFee: 1.49,
    minOrder: 8,
    promo: 'Patatine in regalo',
    address: 'Piazza Duomo 3, Milano',
    featured: true,
    menu: burgerMenu,
  },
  {
    id: 'kebab-istanbul',
    name: 'Kebab Istanbul',
    cuisine: 'Kebab · Mediorientale',
    categories: ['kebab'],
    image: 'https://images.pexels.com/photos/37080266/pexels-photo-37080266.jpeg?auto=compress&cs=tinysrgb&w=800',
    rating: 4.3,
    reviews: 870,
    deliveryTime: '20-30 min',
    deliveryFee: 0.99,
    minOrder: 6,
    promo: null,
    address: 'Via Padova 110, Milano',
    featured: false,
    menu: kebabMenu,
  },
  {
    id: 'green-bowl',
    name: 'Green Bowl',
    cuisine: 'Healthy · Poke',
    categories: ['healthy', 'insalate'],
    image: 'https://images.pexels.com/photos/8481855/pexels-photo-8481855.jpeg?auto=compress&cs=tinysrgb&w=800',
    rating: 4.7,
    reviews: 640,
    deliveryTime: '25-35 min',
    deliveryFee: 1.99,
    minOrder: 10,
    promo: 'Nuovo su IFD',
    address: 'Via Solferino 20, Milano',
    featured: false,
    menu: healthyMenu,
  },
  {
    id: 'pizza-express',
    name: 'Pizza Express 24',
    cuisine: 'Pizza · Fast Food',
    categories: ['pizza', 'burger'],
    image: 'https://images.pexels.com/photos/9993754/pexels-photo-9993754.jpeg?auto=compress&cs=tinysrgb&w=800',
    rating: 4.2,
    reviews: 1980,
    deliveryTime: '15-25 min',
    deliveryFee: 1.99,
    minOrder: 8,
    promo: 'Aperto 24h',
    address: 'Viale Monza 200, Milano',
    featured: false,
    menu: pizzaMenu,
  },
  {
    id: 'mare-nostrum',
    name: 'Mare Nostrum',
    cuisine: 'Pesce · Mediterranea',
    categories: ['healthy', 'pasta'],
    image: 'https://images.pexels.com/photos/566343/pexels-photo-566343.jpeg?auto=compress&cs=tinysrgb&w=800',
    rating: 4.9,
    reviews: 410,
    deliveryTime: '35-50 min',
    deliveryFee: 3.49,
    minOrder: 18,
    promo: null,
    address: 'Via Brera 30, Milano',
    featured: false,
    menu: pastaMenu,
  },
];

export const howItWorks = [
  { icon: 'MapPin', title: 'Inserisci il tuo indirizzo', text: 'Scopri tutti i ristoranti che consegnano nella tua zona.' },
  { icon: 'UtensilsCrossed', title: 'Scegli cosa ordinare', text: 'Sfoglia i menu e aggiungi i tuoi piatti preferiti al carrello.' },
  { icon: 'Bike', title: 'Ricevi a casa', text: 'I nostri rider ti portano tutto caldo e in tempo record.' },
];

export const cities = ['Milano', 'Roma', 'Torino', 'Napoli', 'Bologna', 'Firenze', 'Palermo', 'Genova'];
